import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import List from 'components/Common/List'

type Props = {
  additionalPolicyNotes: Array<string>
}

const getAdditionalPolicyNoteKey = (note: string, index: number) => {
  return `${note}-${index}`
}

const renderAdditionalPolicyNote = (note: string, index: number) => {
  return (
    <BodyText key={getAdditionalPolicyNoteKey(note, index)} as="li" variant="medium">
      {note}
    </BodyText>
  )
}

function AccommodationAdditionalPolicyNotes({ additionalPolicyNotes }: Props) {
  const intl = useIntl()

  const heading = intl.formatMessage({
    id: 'zLreiOlcFhPcjLsWPTKf',
    defaultMessage: 'Please note',
    description: 'Heading for the additional policy notes section within the guest policy area of the room details modal.',
  })

  return (
    <>
      <Heading variant="heading6" as="h4">{heading}</Heading>
      <List>
        {additionalPolicyNotes.map(renderAdditionalPolicyNote)}
      </List>
    </>
  )
}

export default AccommodationAdditionalPolicyNotes
